import EmbeddedRegistrationFormSection, {
  type EmbeddedRegistrationFormSectionData
} from "./EmbeddedRegistrationFormSection";

export type { EmbeddedRegistrationFormSectionData };
export default EmbeddedRegistrationFormSection;
